import { render, staticRenderFns } from "./Headbar.vue?vue&type=template&id=2b0832ad&"
import script from "./Headbar.vue?vue&type=script&lang=js&"
export * from "./Headbar.vue?vue&type=script&lang=js&"
import style0 from "./Headbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports